import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ExamPeriod } from "@types";

export const useAddTimeMonitor = (examPeriod?: ExamPeriod) => {
    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const addTime = async ({ id, deltaSec }: { id: string; deltaSec: number }) => {
        try {
            const response = await axios.post(
                `/api/examinstance/monitor/${id}/addtime`,
                deltaSec,
                { headers: { "Content-Type": "application/json" } }
            );
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.addTimeMonitor"));
        }
    };

    return useMutation({
        mutationFn: addTime,
        onSettled: () => {
            if (examPeriod?.id) {
                queryClient.refetchQueries({ queryKey: ["examPeriods", examPeriod.id, "monitor"] });
            }
        },
    });
};
